import { type FC, type LazyExoticComponent, lazy } from "react"

// auth pages
export { AuthLoginPage, AuthRegisterPage, AuthResetPassPage } from "./auth"

// coach pages
const CoachCalendarAccountsPage: LazyExoticComponent<FC> = lazy(
    (): Promise<{ default: FC }> =>
        import("./coach.calendar/coach.calendar.page.accounts").then(
            ({ CoachCalendarAccountsPage: CA }): { default: FC } => ({
                default: CA
            })
        )
)
const CoachRelinkAccountsPage: LazyExoticComponent<FC> = lazy(
    (): Promise<{ default: FC }> =>
        import("./coach.calendar/coach.calendar.page.relink-accounts").then(
            ({ CoachRelinkAccountsPage: RA }): { default: FC } => ({
                default: RA
            })
        )
)
const CoachLinkAccountsPage: LazyExoticComponent<FC> = lazy(
    (): Promise<{ default: FC }> =>
        import("./coach.calendar/coach.calendar.page.link-accounts").then(
            ({ CoachLinkAccountsPage: LA }): { default: FC } => ({
                default: LA
            })
        )
)
export { CoachCalendarAccountsPage, CoachRelinkAccountsPage, CoachLinkAccountsPage }
export { CoachGroupPage } from "./coach.group"
export { CoachGroupParticipantPage } from "./coach.group-participant"
export { CoachDashboardPage } from "./coach.dashboard"
export { CoachIndividualParticipantPage } from "./coach.individual-participant"
export { CoachCalendarAvailabilityPage, CoachCalendarSetupPage } from "./coach.calendar"

// assistant pages
export { AssistantParticipantsPage } from "./assistant.participants"
export { AssistantParticipantSessionsPage } from "./assistant.participant-sessions"
export { AssistantSwapSessionPage } from "./assistant.swap-session"

// participant pages
const ParticipantDashboardPage: LazyExoticComponent<FC> = lazy(
    (): Promise<{ default: FC }> =>
        import("./participant.dashboard").then(({ ParticipantDashboardPage: D }): { default: FC } => ({
            default: D
        }))
)
const ParticipantChapterPage: LazyExoticComponent<FC> = lazy(
    (): Promise<{ default: FC }> =>
        import("./participant.chapter").then(({ ParticipantChapterPage: C }): { default: FC } => ({
            default: C
        }))
)
const ParticipantCoachingSessionsPage: LazyExoticComponent<FC> = lazy(
    (): Promise<{ default: FC }> =>
        import("./participant.coaching-sessions").then(({ ParticipantCoachingSessionsPage: CS }): { default: FC } => ({
            default: CS
        }))
)
export { ParticipantDashboardPage, ParticipantChapterPage, ParticipantCoachingSessionsPage }
export { ParticipantDiagnosticSummaryPage } from "./participant.diagnostic-summary"
